export const ADD_LABEL_POPUP_WRAPPER_CLASS_NAME = "event-label-popup";
export const ADD_LABEL_POPUP_CONTENT_CLASS = "popuptext";
export const LABEL_INPUT_CLASS_NAME = "event-label-textarea-input-label";
export const LABEL_INPUT_MAX_LENGTH = 160;
export const ADD_LABEL_INPUT_ACTIONS_WRAPPER_CLASS_NAME = "add-label-action";
export const BUTTON_CANCEL_ADD_LABEL_CLASS_NAME = "add-label-cancel";
export const BUTTON_SAVE_LABEL_CLASS_NAME = "add-label-save";
export const DEFAULT_IS_DISPLAY_LABEL = true;
export const CUSTOM_ELEMENT_IN_CHART_ATTR = 'custom-class-name';
export const DEFAULT_CUSTOM_LABELS_TRANSLATE_Y = 6;
export const SMALL_LABEL_FONT_SIZE = 8;
export const NORMAL_LABEL_FONT_SIZE = 10;
export const LARGE_LABEL_FONT_SIZE = 12;
export const SHOW_LABEL_TEXT_PADDING_RIGHT = 140;
export const LABEL_SIZE_TEXT_PADDING_RIGHT = 260;
export const CHANGE_LABEL_Z_INDEX_FUNCTION_NAME = "changeLabelZIndex";
export const CHART_HEIGHT_WHEN_NOT_DISPLAY_LABEL = 240;
export const CHART_HEIGHT_WHEN_DISPLAY_LABEL = 310;
export const CHART_MARGIN_BOTTOM_WHEN_DISPLAY_LABEL = 100;
export const CHART_MARGIN_BOTTOM_WHEN_NOT_DISPLAY_LABEL = 30;
export const CHART_MARGIN_LEFT_WHEN_DISPLAY_LABELS = 100;
export const CHART_MARGIN_RIGHT_WHEN_DISPLAY_LABELS = 100;
export const CHART_MARGIN_LEFT_WHEN_NOT_DISPLAY_LABELS = 60;
export const CHART_MARGIN_RIGHT_WHEN_NOT_DISPLAY_LABELS = 30;
export const CHART_MARGIN_TOP = 45;
export const CHART_BACKGROUND_COLOR = "white";
export const EVENT_LABEL_WRAPPER_CLASS_NAME = "label-box";
export const HIGHCHART_ANNOTATION_LABEL_BOX_CLASS = "highcharts-annotation-label-box";
export const BUTTON_EDIT_LABEL_CLASSNAME = "button-edit-annotation";
export const LABEL_TEXT_CLASS = "event-label-text";
export const BUTTON_DELETE_LABEL_CLASSNAME = "button-delete-annotation";
export const MARKER_LINE = "marker-line";
export const MAX_DAYS_FOR_TIME_CONSTANT_1_TICK_LABELS = 21;
export const MIN_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS = 21;
export const MAX_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS = 90;
export const MIN_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS = 90;
export const MAX_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS = 180;
export const MIN_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS = 180;
export const MAX_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS = 365;
export const TIME_CONSTANT = 24 * 3600 * 1000;
export const AXIS_POINT_LIMIT = 5;
export const DATE_TIME_IN_YYYY_MM_DD_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const BUTTON_SET_FONT_SIZE_SMALL_PADDING_FROM_THE_LABEL_SIZES_TEXT = 60;
export const BUTTON_SET_FONT_SIZE_MEDIUM_PADDING_FROM_THE_LABEL_SIZES_TEXT = 75;
export const BUTTON_SET_FONT_SIZE_LARGE_PADDING_FROM_THE_LABEL_SIZES_TEXT = 90;
export const BUTTON_SET_FONT_SIZE_SMALL_ADJUST_CUSTOM_TRANSLATE_Y = 1;
export const BUTTON_SET_FONT_SIZE_MEDIUM_ADJUST_CUSTOM_TRANSLATE_Y = 0;
export const BUTTON_SET_FONT_SIZE_LARGE_ADJUST_CUSTOM_TRANSLATE_Y = -2;
export const LABEL_SIZE_DISPLAY_TEXT = "Label size";
export const SHOW_LABELS_BUTTON_TEXT = "Show Labels";
export const CHECKBOX_SHOW_HIDE_LABELS_PADDING_RIGHT = SHOW_LABEL_TEXT_PADDING_RIGHT - 70;
export const CHECKBOX_SHOW_HIDE_LABELS_PADDING_TOP = 8;
export const CHECKBOX_SHOW_HIDE_LABELS_SIZE = 12;
export const DEFAULT_TOOLTIP = {
    useHTML: false,
    shape: 'callout',
    borderColor: undefined,
    formatter: undefined,
    borderWidth: 1,
    borderRadius: 3,
    backgroundColor: 'rgba(247,247,247,0.85)',
    shadow: true,
};
export const POPUP_ADD_EVENT_LABEL_MARGIN_LEFT = 20;
export const POPUP_ADD_EVENT_LABEL_MARGIN_TOP = 60;
export const X_AXIS_LABEL_CUSTOM_TOOLTIP_STYLE = {
    shape: 'rect',
    shadow: false,
    borderColor: '#B8B8B8',
    borderWidth: 0.1,
    style: {
    color: '#666666'
    },
    borderRadius: 1,
    backgroundColor: '#FFFFFF',
}
export const ADD_EVENT_LABEL_TEXT = "Add Event Label";
export const EDIT_EVENT_LABEL_TEXT = "Edit Event Label";
export const DELETE_EVENT_LABEL_BOX_BACKGROUND_COLOR = "#FFFBE9";
export const BUTTON_CANCEL_DELETE_BACKGROUND_COLOR = "#F6F6F6";
export const DELETE_ACTION_CONFIRM_CLASS = "delete-action-confirm";
export const BUTTON_YES_DELETE_CLASS = "yes-delete-label";
export const BUTTON_CANCEL_DELETE_CLASS = "no-delete-label";
export const SPLINE_CHART = 'spline';

export const DATA_KEY = 'data';
export const TOTAL_TREND_INDEX = 0;
export const POSITIVE_TREND_INDEX = 1;
export const NEGATIVE_TREND_INDEX = 2;
export const NEUTRAL_TREND_INDEX = 3;
export const JOY_TREND_INDEX = 0;
export const FEAR_TREND_INDEX = 1;
export const SADNESS_TREND_INDEX = 2;
export const ANGER_TREND_INDEX = 3;
export const DATE_KEY_INDEX = 0;
export const COUNT_INDEX = 1;

export const PERCENTAGE_TREND_CHART_Y_AXIS_INTERVAL      = 20;
export const PERCENTAGE_TREND_CHART_MAXIMUM_Y_AXIS_VALUE = 100;



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/constants/eventLabellingChartConstants.js